module.exports = __webpack_public_path__ + "732533da0d11d6eaea4e41de39fdcc21.png";